import React from "react";
import {Grid, Typography} from "@mui/material";
import {lxStyled} from "@lxo-blocks/react";
import {isIE11, isOldEdgeOrIE} from "../_polyfill_/polyfill";

const PREFIX = 'BrowserUnsupported';
const classes = {
    text: `${PREFIX}-text`
}
const BrowserUnsupportedContainer = lxStyled(Grid)(({theme}) => ({
    backgroundColor: `rgba(224, 55, 48, 0.7)`,
    [`.${classes.text}`]: {
        color: `${theme.palette.text.secondary}`
    }
}));

export interface BrowserUnsupportedProps {
    isIE11: boolean;
    isOldEdgeOrIE: boolean;
    sx?: any;
}

export default function BrowserUnsupported(props: BrowserUnsupportedProps) {
    return <BrowserUnsupportedContainer container
                                        sx={props.sx}
                                        justifyContent="center">
        <Grid item className={`${classes.text}`}>
            {(isIE11) &&
            <Typography sx={{py: 2}} component="div" variant="subtitle2">Sie verwenden den Internet Explorer 11. Wir
              empfehlen, einen aktuellen Browser zu benutzen, damit lexoffice einwandfrei funktioniert.</Typography>}
            {(isOldEdgeOrIE && !isIE11) &&
            <Typography sx={{py: 2}} component="div" variant="subtitle2">Sie verwenden Microsoft Edge oder den Internet
              Explorer in einer sehr alten Version. Wir empfehlen einen aktuellen Browser zu benutzen, damit lexoffice
              einwandfrei funktioniert.</Typography>}
        </Grid>
    </BrowserUnsupportedContainer>
}